import React from "react";

import { faCircleCheck } from "@fortawesome/pro-solid-svg-icons";

import { AvatarProfile, ButtonStandard, Chip, Text } from "@performyard/py-components";

export type GroupHeaderRowProps = {
	userID?: string;
	groupManagerId: string | null;
	groupManagerName: string | null;
	groupSubmitted: boolean;
	isRefreshingGroup: boolean;
	onSubmitDecisions: () => void;
	cycleStatus: string;
};

export const GroupHeaderRow = ({
	userID,
	groupManagerId,
	groupManagerName,
	groupSubmitted,
	isRefreshingGroup,
	onSubmitDecisions,
	cycleStatus,
}: GroupHeaderRowProps): React.ReactElement => (
	<div className="flex items-center px-4">
		<div className="flex min-h-9 w-[120px] min-w-0 flex-1 shrink-0 items-center">
			{(!groupManagerName || groupManagerId === userID) && (
				<Text size="paragraph-1" weight="semi-bold">
					My Decisions
				</Text>
			)}
			{groupManagerName && groupManagerId !== userID && (
				<div className="flex items-center gap-2 text-sm whitespace-nowrap text-neutral-7">
					<AvatarProfile
						textSize="paragraph-3"
						textWeight="semi-bold"
						textColor="neutral-9"
						noLink={true}
						employeeId={groupManagerId ?? ""}
						employeeName={groupManagerName ?? ""}
					/>
					<Chip label="You are Acting Manager" color="neutral" size={28}></Chip>
				</div>
			)}
		</div>
		<div className="ml-auto w-[120px] shrink-0 pr-4">
			<div className="flex justify-start">
				{!groupSubmitted && (
					<ButtonStandard
						size="medium"
						dangerouslySetClassName="!w-auto"
						onClick={onSubmitDecisions}
						disabled={isRefreshingGroup || cycleStatus === "scheduled"}
					>
						Submit Decisions
					</ButtonStandard>
				)}
				{groupSubmitted && (
					<ButtonStandard
						iconLeft={faCircleCheck}
						size="medium"
						dangerouslySetClassName="!h-8 !w-[120px] !min-w-[70px] !gap-1 !px-2 !opacity-100"
						onClick={onSubmitDecisions}
						disabled={true}
						variant="solid"
					>
						Submitted
					</ButtonStandard>
				)}
			</div>
		</div>
	</div>
);
